// extracted by mini-css-extract-plugin
export default {"resultsPageDiv":"SearchResults_resultsPageDiv__WnY4c","noResults":"SearchResults_noResults__yMRF2","warning":"SearchResults_warning__OADjb"};